import { isFedRamp } from '@atlassian/atl-context';

// We can now clean this package up and rely on isFedRamp
export const isDevopsFeatureDisabledInFedRamp = (): boolean => isFedRamp();
